export interface ICmsBannerContainerProps {
  pwaCallToActionLink?: string;
  url: ICmsBannerUrl;
}

export interface ICmsBannerProps {
  source: string;
  link?: string;
}

export interface ICmsBannerData {
  banners: ICmsBanner[];
}

export interface ICmsBanner {
  pwaCallToActionLink?: string;
  url: string;
  tabletUrl: string;
  desktopUrl: string;
}

export interface ICmsBannerUrl {
  desktopUrl: string;
  tabletUrl: string;
  url: string;
}

export enum CmsBannerType {
  unregisteredUser = 'unregistered_user',
  userWithoutVouchers = 'user_without_welcome_discounts_vouchers',
  arlBanner = 'arl_banner_pwa',
}
